import { createPreferencesStore } from '@emfit/shared-store';
import { Storage } from 'src/storage';

export type {
  ViewMode,
  ViewModePreferences,
  UserPreferences,
} from '@emfit/shared-store';

/**
 * Care app preferences store — localStorage only.
 *
 * User settings (locale, timezone, date/time format) are owned by UserStore
 * which syncs with POST /v1/user/update-information. This store handles
 * frontend-only preferences (theme, view modes, dashboard days, etc.).
 */
export const PreferencesStore = createPreferencesStore({
  namespace: 'care',
  getUserId: () => {
    const userData = Storage.get('userData');
    if (!userData) return null;
    try {
      const parsed =
        typeof userData === 'string' ? JSON.parse(userData) : userData;
      return parsed?.id ?? null;
    } catch {
      return null;
    }
  },
});
